export default __webpack_public_path__ + "static/media/calendar.06ca24fb.svg";